module.exports = __webpack_public_path__ + "img/insert.37769968.png";